export default __webpack_public_path__ + "static/media/androidQrCode.fa8852a7.png";